// Paginate a server side row data response
export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  per_page: number
  has_more: boolean
}

export type PaginationFilters = {
  limit?: number
  skip?: number
}

/**
 * Paginate server side row data. This is used for compatability with grids that don't support server side pagination natively.
 * Ideally, we'd update the grid's row model to use server side pagination directly.
 * @param data
 * @param filters
 * @returns
 */
export function paginateData<T, F extends PaginationFilters>(
  data: T[] | undefined,
  filters: F,
): PaginatedResponse<T> {
  if (!data) {
    return {
      data: [],
      total: 0,
      page: 1,
      per_page: filters.limit || 100,
      has_more: false,
    }
  }

  const skip = filters.skip || 0
  const limit = filters.limit || 100
  const paginatedData = data.slice(skip, skip + limit)

  return {
    data: paginatedData,
    total: data.length,
    page: Math.floor(skip / limit) + 1,
    per_page: limit,
    has_more: skip + limit < data.length,
  }
}
